<template>
  <div class="signup">
    <div class="text-center mt-3">
      <h1 class="font-semibold text-lg">Create an account</h1>
      <p class="text-sm">Get your free MuleEx account now.</p>
    </div>

    <div class="w-full sm:w-12/12 mx-auto px-3">
      <div v-if="!hasType" class="text-darkBlue h-screen">
        <div class="text-center w-full md:w-3/5 mx-auto my-12">
          <h1 class="text-lg md:text-3xl font-bold">Sign up as</h1>
        </div>

        <div class="w-full md:w-4/5 mx-auto font-semibold mt-12">
          <div class="flex gap-4 items-center">
            <div :class="{
              selected: mainAccountType == '3PL',
              groupselected: onboardingType == '3PL',
            }" class="single-option shadow" @click="toggleAccountType('3PL')">
              <div class="single-option__inner">
                <div class="single-option__">
                  <p>{{ logisticsTitle }}</p>
                  <!-- <p>Organization</p> -->
                </div>
                <div class="single-option__select-circle">
                  <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L6.75697 7L12.5139 1" stroke="#10233E" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                  <!-- <div class="single-option__select-circle__inner"></div> -->
                </div>
              </div>
              <div class="actions" v-if="mainAccountType == '3PL'">
                <div :class="{ selected: accountType == 'individual' }" class="single-option shadow"
                  @click="selectAccountType('individual', 'logistics', 'I have only 1 fleet (e.g. bike, car, bus, truck, etc)')">
                  <div class="single-option__inner">
                    <div class="single-option__">
                      <p>I have only 1 fleet (e.g. bike, car, bus, truck, etc)</p>
                    </div>
                    <div class="single-option__select-circle">
                      <div class="single-option__select-circle__inner"></div>
                    </div>
                  </div>
                </div>
                <div :class="{ selected: accountType == 'organization' }" class="single-option shadow" @click="
                  selectAccountType('organization', 'logistics', 'I have multiple fleets (e.g. bike, car, bus, truck, etc)')
                  ">
                  <div class="single-option__inner">
                    <div class="single-option__">
                      <p>I have multiple fleets (e.g. bike, car, bus, truck, etc)</p>
                    </div>
                    <div class="single-option__select-circle">
                      <div class="single-option__select-circle__inner"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex gap-4 items-center">
            <div :class="{
              selected: mainAccountType == 'ondemand',
              groupselected: onboardingType == 'ondemand',
            }" class="single-option shadow single-option" @click="toggleAccountType('ondemand')">
              <div class="single-option__inner">
                <div class="single-option__">
                  <p>{{ customerTitle }}</p>
                </div>
                <div class="single-option__select-circle">
                  <svg width="14" height="8" viewBox="0 0 14 8" fill="none">
                    <path d="M1 1L6.75697 7L12.5139 1" stroke="#10233E" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                  <!-- <div class="single-option__select-circle__inner"></div> -->
                </div>
              </div>
              <div class="actions" v-if="mainAccountType == 'ondemand'">
                <div :class="{ selected: accountType == 'individual' }" class="single-option shadow"
                  @click="selectAccountType('individual', 'customer', 'Individual (Private customer)')">
                  <div class="single-option__inner">
                    <div class="single-option__">
                      <p>Individual (Private)</p>
                    </div>
                    <div class="single-option__select-circle">
                      <div class="single-option__select-circle__inner"></div>
                    </div>
                  </div>
                </div>

                <!-- <div :class="{ selected: accountType == 'enterprise_customer' }" class="single-option shadow" @click="
                  selectAccountType(
                    'enterprise_customer',
                    'customer',
                    'Organization (Enterprise customer) '
                  )
                  ">
                  <div class="single-option__inner">
                    <div class="single-option__">
                      <p>Organisation (Enterprise)</p>
                    </div>
                    <div class="single-option__select-circle">
                      <div class="single-option__select-circle__inner"></div>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="hasType">
        <div class="mt-2">
          <label class="label font-semibold">First Name <span class="text-red-500">*</span></label>
          <base-input placeholder="Enter Your First Name" v-model="newUser.firstname">
            <template v-slot:icon>
              <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14.2095 13.262C13.8416 12.3734 13.3077 11.5662 12.6375 10.8854C11.9693 10.2026 11.1778 9.65828 10.3066 9.28238C10.2988 9.2784 10.291 9.27641 10.2832 9.27243C11.4984 8.37745 12.2883 6.91963 12.2883 5.27486C12.2883 2.55014 10.1233 0.342529 7.45115 0.342529C4.77899 0.342529 2.61397 2.55014 2.61397 5.27486C2.61397 6.91963 3.40391 8.37745 4.61905 9.27442C4.61125 9.2784 4.60345 9.28039 4.59565 9.28436C3.72184 9.66026 2.93775 10.1992 2.26483 10.8874C1.59525 11.5687 1.0614 12.3758 0.692749 13.264C0.330589 14.1337 0.135267 15.066 0.117358 16.0106C0.116838 16.0319 0.120489 16.053 0.128097 16.0727C0.135706 16.0925 0.147117 16.1105 0.161658 16.1257C0.1762 16.1409 0.193578 16.153 0.212768 16.1612C0.231958 16.1695 0.252573 16.1737 0.273396 16.1737H1.44368C1.5295 16.1737 1.59777 16.1041 1.59972 16.0186C1.63873 14.4832 2.24338 13.0453 3.31224 11.9554C4.41816 10.8277 5.88686 10.2072 7.45115 10.2072C9.01543 10.2072 10.4841 10.8277 11.5901 11.9554C12.6589 13.0453 13.2636 14.4832 13.3026 16.0186C13.3045 16.1061 13.3728 16.1737 13.4586 16.1737H14.6289C14.6497 16.1737 14.6703 16.1695 14.6895 16.1612C14.7087 16.153 14.7261 16.1409 14.7406 16.1257C14.7552 16.1105 14.7666 16.0925 14.7742 16.0727C14.7818 16.053 14.7855 16.0319 14.7849 16.0106C14.7654 15.06 14.5723 14.1352 14.2095 13.262ZM7.45115 8.69567C6.55588 8.69567 5.71327 8.33967 5.07937 7.69329C4.44546 7.04692 4.09633 6.18774 4.09633 5.27486C4.09633 4.36198 4.44546 3.5028 5.07937 2.85643C5.71327 2.21005 6.55588 1.85405 7.45115 1.85405C8.34641 1.85405 9.18902 2.21005 9.82292 2.85643C10.4568 3.5028 10.806 4.36198 10.806 5.27486C10.806 6.18774 10.4568 7.04692 9.82292 7.69329C9.18902 8.33967 8.34641 8.69567 7.45115 8.69567Z"
                  fill="#FCC210" />
              </svg>
            </template>
          </base-input>
        </div>
        <div class="mt-2">
          <label class="label font-semibold">Last Name <span class="text-red-500">*</span></label>
          <base-input placeholder="Enter Your Last Name" v-model="newUser.lastname">
            <template v-slot:icon>
              <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14.2095 13.262C13.8416 12.3734 13.3077 11.5662 12.6375 10.8854C11.9693 10.2026 11.1778 9.65828 10.3066 9.28238C10.2988 9.2784 10.291 9.27641 10.2832 9.27243C11.4984 8.37745 12.2883 6.91963 12.2883 5.27486C12.2883 2.55014 10.1233 0.342529 7.45115 0.342529C4.77899 0.342529 2.61397 2.55014 2.61397 5.27486C2.61397 6.91963 3.40391 8.37745 4.61905 9.27442C4.61125 9.2784 4.60345 9.28039 4.59565 9.28436C3.72184 9.66026 2.93775 10.1992 2.26483 10.8874C1.59525 11.5687 1.0614 12.3758 0.692749 13.264C0.330589 14.1337 0.135267 15.066 0.117358 16.0106C0.116838 16.0319 0.120489 16.053 0.128097 16.0727C0.135706 16.0925 0.147117 16.1105 0.161658 16.1257C0.1762 16.1409 0.193578 16.153 0.212768 16.1612C0.231958 16.1695 0.252573 16.1737 0.273396 16.1737H1.44368C1.5295 16.1737 1.59777 16.1041 1.59972 16.0186C1.63873 14.4832 2.24338 13.0453 3.31224 11.9554C4.41816 10.8277 5.88686 10.2072 7.45115 10.2072C9.01543 10.2072 10.4841 10.8277 11.5901 11.9554C12.6589 13.0453 13.2636 14.4832 13.3026 16.0186C13.3045 16.1061 13.3728 16.1737 13.4586 16.1737H14.6289C14.6497 16.1737 14.6703 16.1695 14.6895 16.1612C14.7087 16.153 14.7261 16.1409 14.7406 16.1257C14.7552 16.1105 14.7666 16.0925 14.7742 16.0727C14.7818 16.053 14.7855 16.0319 14.7849 16.0106C14.7654 15.06 14.5723 14.1352 14.2095 13.262ZM7.45115 8.69567C6.55588 8.69567 5.71327 8.33967 5.07937 7.69329C4.44546 7.04692 4.09633 6.18774 4.09633 5.27486C4.09633 4.36198 4.44546 3.5028 5.07937 2.85643C5.71327 2.21005 6.55588 1.85405 7.45115 1.85405C8.34641 1.85405 9.18902 2.21005 9.82292 2.85643C10.4568 3.5028 10.806 4.36198 10.806 5.27486C10.806 6.18774 10.4568 7.04692 9.82292 7.69329C9.18902 8.33967 8.34641 8.69567 7.45115 8.69567Z"
                  fill="#FCC210" />
              </svg>
            </template>
          </base-input>
        </div>
        <div class="mt-2">
          <label class="label font-semibold">Email <span class="text-red-500">*</span></label>
          <base-input placeholder="Enter Your Email" errorText="Please enter a valid email Address"
            v-model="newUser.email" :validation="/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
              newUser.email
            )
              ">
            <template v-slot:icon>
              <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16.941 0.283447H1.96132C1.63025 0.283447 1.31273 0.417552 1.07863 0.656259C0.84453 0.894966 0.713013 1.21872 0.713013 1.55631V11.7392C0.713013 12.0768 0.84453 12.4005 1.07863 12.6392C1.31273 12.8779 1.63025 13.012 1.96132 13.012H16.941C17.272 13.012 17.5896 12.8779 17.8237 12.6392C18.0578 12.4005 18.1893 12.0768 18.1893 11.7392V1.55631C18.1893 1.21872 18.0578 0.894966 17.8237 0.656259C17.5896 0.417552 17.272 0.283447 16.941 0.283447ZM15.5678 1.55631L9.45114 5.8713L3.33445 1.55631H15.5678ZM1.96132 11.7392V2.13546L9.09538 7.16962C9.19986 7.24352 9.32398 7.28313 9.45114 7.28313C9.5783 7.28313 9.70243 7.24352 9.80691 7.16962L16.941 2.13546V11.7392H1.96132Z"
                  fill="#FCC210" />
              </svg>
            </template>
          </base-input>
        </div>
        <div class="mt-2">
          <label class="label font-semibold">Phone Number (Preferably a WhatsApp number) <span
              class="text-red-500">*</span></label>
          <vue-tel-input v-model="newUser.mobile_no" :preferredCountries="['Nigeria']"
            @keyup="validatePhone"></vue-tel-input>
          <div v-if="isValidPhone && newUser.mobile_no.length > 0">
            <p class="text-red-600">Phone number must be numeric values only</p>
          </div>
          <div v-if="isValidPhoneLength && newUser.mobile_no.length > 0">
            <p class="text-red-600">Phone number must be 11 characters long</p>
          </div>
        </div>
        <div>
          <input type="checkbox" class="h-5 w-5 border border-red" v-model="term_of_use" />
          <p class="text-deepBlue text-center font-semibold text-sm py-3">
            <base-checkbox label="" v-model="terms_of_use" :bold="true" /> By registering
            you agree to the MuleEx
            <a href="http://muleex-landing-new.s3-website.eu-west-2.amazonaws.com/userPolicies/termsAndCondition"
              target="_blank" class="text-primary-yellow text-[inherit]">Terms of Use</a>
          </p>
        </div>

        <p @click="hasType = false" class="text-sm text-center cursor-pointer text-primary-yellow pl-2 my-3">
          Sign up differently
        </p>

        <div class="mt-3">
          <base-button :disabled="isValidForm" text="Continue" width="w-full" p="px-12 py-2" :loading="loading"
            @click="submitUserDetails" />
        </div>
      </div>
    </div>

    <modal :showModal="showModal" @close-modal="showModal = false" width="35">
      <div class="confirm-email">
        <p class="text-sm text-center py-4">
          It looks like you are using a private e-mail. It is advisable to use a company's
          e-mail. Please confirm to continue or edit.
        </p>
        <div class="button-wrapper">
          <button class="button button-long confirm" @click="(showModal = false), (privateEmailConfirmed = true)">
            Confirm
          </button>
          <button class="button-primary button button-long" @click="editEmail">
            Edit
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import isNumber from "@/mixins/isNumber";
export default {
  name: "signup",
  data() {
    return {
      newUser: {
        firstname: "",
        lastname: "",
        mobile_no: "",
        email: "",
        checked: true,
      },
      signedUser: {},
      terms_of_use: false,
      showModal: false,
      loading: false,
      privateEmailConfirmed: false,
      hasType: false,
      accountType: undefined,
      mainAccountType: "organization",
      onboardingType: "",
      savingAccountType: false,
      logisticsTitle: "3rd Party Logistics Provider",
      customerTitle: "Customer",
      accountGroup: "",
      term_of_use: false
    };
  },
  computed: {
    isValidEmail() {
      let validate = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return validate.test(this.newUser.email);
    },
    isValidPhone() {
      let phone = this.newUser.mobile_no;
      var patt = /[a-z]+/i;
      return patt.test(phone);
    },
    isValidPhoneLength() {
      return this.newUser.mobile_no.replace(/\s+/g, "").length != 11 ? true : false;
    },
    isValidForm() {
      return this.newUser.firstname.length <= 0 ||
        this.newUser.lastname.length <= 0 ||
        this.newUser.mobile_no.length <= 0 ||
        !this.isValidEmail ||
        this.isValidPhone ||
        this.isValidPhoneLength ||
        !this.terms_of_use
        ? true
        : false;
    },
  },
  watch: {
    "newUser.email"() {
      let { email } = this.newUser;
      if (email.indexOf("@") >= 0 && email.indexOf(".") >= 0) {
        let start = email.indexOf("@") + 1;
        let end = email.indexOf(".");
        let emailClient = email.slice(start, end);
        if (emailClient == "gmail" || emailClient == "yahoo") {
          if (!this.privateEmailConfirmed) {
            this.showModal = false;
          }
        }
      }
    },
  },
  mixins: [isNumber],
  methods: {
    validatePhone() { },
    selectAccountType(accountType, group, title) {
      this.accountGroup = group;
      switch (group) {
        case "logistics":
          this.logisticsTitle = title;
          break;
        case "customer":
          this.customerTitle = title;
          break;
      }
      this.accountType = accountType;
      this.accountTypeObject = {
        mainAccountType: this.mainAccountType,
        accountType: this.accountType,
      };
      this.hasType = true;
      this.$store.dispatch("saveAccountType", this.accountTypeObject);
    },
    toggleAccountType(accountType) {
      this.onboardingType = accountType;
      if (this.mainAccountType == accountType) {
        this.mainAccountType = "";
      } else {
        this.mainAccountType = accountType;
      }
    },
    async submitUserDetails() {
      this.saveDetailsToLocalStorage();
      this.loading = true;
      // the backend requires the checked property to be a string
      this.newUser.checked = String(this.newUser.checked);
      let requestObject = this.newUser;
      try {
        const { data: response } = await this.$_signUpUser(requestObject);
        this.saveUserId(response.data);
        this.saveAccountType();
        this.signedUser = response?.data
        // this.handleSuccessfulUserSignup(response.data);
      } catch (error) {
        this.loading = false;
        // Navigate user to otp page if registration is not complete
        if (error?.response?.status === 307 && error?.response?.data?.data?.redirect && error?.response?.data?.data?.type === 'incomplete_password') {
          this.saveUserId(error?.response?.data?.data)
          this.$router.push(`/signup/authentication?quantumUserId=${error?.response?.data?.data?.quantum_user_id}`);
        } else {
          this.generateToast(
            `${error?.response?.data?.errors}, Please login`,
            "error"
          );
        }
      }
    },
    async saveAccountType() {
      let accountTypeObject = JSON.parse(localStorage.getItem("accountTypeObject"));
      this.savingAccountType = true;

      if (accountTypeObject.accountType != "N/A") {
        // accounttypeRequest
        if (accountTypeObject.accountType == 'enterprise_customer') {
          accountTypeObject.accountType = 'organization'
        }
        let accountTypeRequest = {
          type: accountTypeObject.accountType,
        };
        let userId = localStorage.getItem("userId");
        accountTypeRequest.userId = userId;

        let userCaseRequest = {
          // can be termed use case
          onboardingType: accountTypeObject.mainAccountType,
        };
        // let quantumUserId = localStorage.getItem("quantumUserId");
        userCaseRequest.userId = userId;

        try {
          let usecaseresponse = await this.$_saveUserUseCase(userCaseRequest);

          let acounttyperesponse = await this.$_saveUserAccountType(
            accountTypeRequest
          );
          Promise.all([usecaseresponse, acounttyperesponse]).then(() => {
            this.handleSuccessfulResponse();
          });

        } catch (error) {
          this.savingAccountType = false;
          this.handleError(error);
        }
      } else {
        this.savingAccountType = false;
        await this.generateToast(
          "Feature not available yet! try another..",
          "error"
        );
      }
    },
    handleSuccessfulResponse() {
      if (!this.signedUser?.userId) {
        this.generateToast("Error", "Userid not found");
        this.loading = false
        return
      }
      localStorage.setItem("account-type", this.accountType);
      this.$router.push(`/signup/authentication`);
      // this.$router.push("/onboarding/account-owner");
    },
    saveUserId(data) {
      localStorage.setItem("userId", data?.userId || data?.user_id);
    },
    handleSuccessfulUserSignup() {
      this.loading = false;
      this.generateToast("Success", "success");
      this.$router.push(`/signup/authentication`);
    },
    saveDetailsToLocalStorage() {
      localStorage.setItem("account-owner", JSON.stringify(this.newUser));
    },
    editEmail() {
      this.newUser.email = "";
      this.showModal = false;
    },
  },
};
</script>

<style>
.actions {
  position: absolute;
  background: #ffffff;
  top: 80px;
  z-index: 999;
  font-size: 0.9rem;
  width: 100%;
  background: #ffffff;
  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 10px;
  padding: 1rem;

  span {
    padding-right: 0.25rem;
  }

  >div {
    display: flex;
    align-items: center;
    padding: 0.75rem;

    &:hover {
      background: rgb(225, 225, 225);
    }
  }

  .disabled {
    opacity: 0.5;

    &:hover {
      background: none;
    }
  }
}

.single-option {
  width: 100%;
  height: 4.5rem;
  border-radius: 5px;
  margin: 0.75rem 0;
  background: #ffffff;
  display: flex;
  align-items: center;
  cursor: pointer;
  /* transition: transform ease 0.5s; */
  border: 1px solid #dae8f6;
  position: relative;
}

.single-option.selected {
  border: none;
  background: #fbc210;
}

.groupselected {
  border: none;
  background: #fbc210;
}

.single-option__inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem;
  padding: 0 0.5rem;
  width: 100%;
  height: 70%;
  border-radius: 5px;
}

/* .single-option.selected .single-option__inner {
} */

.single-option__select-circle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  border: 0.5px solid #eff2f7;
}

.single-option__select-circle__inner {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: #eff2f7;
}

.disabled-option {
  color: rgba(174, 174, 185, 0.956);
  background-color: #e7e7e9;
}

@media screen and (max-width: 768px) {
  .single-option {
    width: 90vw;
  }
}

.disabled-option {
  @apply py-2 my-4 pr-3 cursor-pointer;
}

.active-tab {
  @apply text-primary-black bg-primary-yellow;
}
</style>
